import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpService,
	GET,
	Adapter,
	Body,
	POST,
	Query,
} from "@royalty/httpclient";
import { SmartSearchModel } from "src/app/core/smartsearch/smartsearch";

@Injectable()
export class UnitService extends HttpService {
	@GET("unit/GetAllUnits")
	@Adapter(null, { isAdmin: true })
	getUnits(data: SmartSearchModel): Observable<any> {
		return null;
	}

	@POST("unit/CreateNewUnit")
	@Adapter(null, { isAdmin: true })
	createUnit(@Body data: string): Observable<any> {
		return null;
	}

	@POST("unit/UpdateUnit")
	@Adapter(null, { isAdmin: true })
	updateUnit(@Body data: string): Observable<any> {
		return null;
	}

	@POST("unit/DeleteUnit")
	@Adapter(null, { isAdmin: true })
	deleteUnit(@Body data: string): Observable<any> {
		return null;
	}

	@GET("unit/GetUnitById")
	@Adapter(null, { isAdmin: true })
	getUnit(@Query("id") id: number): Observable<any> {
		return null;
	}

	@GET("unit/GetUnitList")
	@Adapter(null, { isAdmin: true })
	getUnitList(): Observable<any> {
		return null;
	}
}
